const toString = value => (value != null ? value.toString() : "");

const ensureString = value => (typeof value !== "string" ? toString(value) : value);

const padLeft = (value, width) => ensureString(value).padEnd(width);

const padRight = (value, width) => ensureString(value).padStart(width);

const padding = (value, lang, width) =>
	width > 0 // checking if widht positive
		? padLeft(value, width)
		: padRight(value, -width);

export default padding;
